// Callback initiated
export const CALLBACK_STATUS_INITIATED = 1
// Callback requested
export const CALLBACK_STATUS_REQUESTED = 2
